export function generateNumberSequence(n) {
  const sequence = [];
  for (let i = 1; i <= n; i++) {
    sequence.push(i);
  }
  return sequence;
}
